export default "__VITE_ASSET__f42a0ec9__"